import { RecoverPasswordService } from 'application/services/recover-password'
import { apiLogin } from 'infra/adapters/http-client-adapter'

export const handleRecoverPassword = new RecoverPasswordService(apiLogin)
